export type Comic = {
  id: string;
  title: string;
  author: string;
  category: string;
  cover: string;
  tags: string[];
  chapters: string;
  rating: string;
  status: string;
  desc: string;
  heat: string;
};

export const comicCategories: { name: string; icon: string; count: string; color: string }[] = [
  { name: '热血冒险', icon: 'ri-fire-fill', count: '1,286 部', color: 'primary' },
  { name: '恋爱甜宠', icon: 'ri-heart-3-fill', count: '968 部', color: 'accent' },
  { name: '玄幻修仙', icon: 'ri-sparkling-2-fill', count: '1,045 部', color: 'primary' },
  { name: '悬疑推理', icon: 'ri-search-eye-line', count: '652 部', color: 'secondary' },
  { name: '搞笑日常', icon: 'ri-emotion-laugh-fill', count: '783 部', color: 'accent' },
  { name: '科幻机甲', icon: 'ri-robot-2-line', count: '521 部', color: 'secondary' },
  { name: '都市职场', icon: 'ri-building-4-line', count: '874 部', color: 'primary' },
  { name: '古风武侠', icon: 'ri-sword-fill', count: '709 部', color: 'accent' },
];

export const featuredComics: Comic[] = [
  {
    id: 'star-fight',
    title: '星焰纪元',
    author: '青岚工作室',
    category: '热血冒险',
    cover: 'https://readdy.ai/api/search-image?query=dynamic%20manga%20cover%20illustration%20of%20a%20young%20hero%20holding%20a%20glowing%20flame%20sword%2C%20fiery%20orange%20and%20deep%20warm%20background%2C%20dramatic%20action%20pose%2C%20vibrant%20comic%20art%20style%2C%20clean%20composition&width=600&height=800&seq=comic-star-fight&orientation=portrait',
    tags: ['热血', '冒险', '成长'],
    chapters: '更新至 326 话',
    rating: '9.6',
    status: '连载中',
    desc: '少年林焰在废土中觉醒星火之力，踏上守护故土的燃血冒险之旅。',
    heat: '热榜第 1',
  },
  {
    id: 'sweet-campus',
    title: '心动补习课',
    author: '橘子汽水',
    category: '恋爱甜宠',
    cover: 'https://readdy.ai/api/search-image?query=adorable%20romance%20manga%20cover%20of%20a%20boy%20and%20girl%20in%20school%20uniforms%20sharing%20a%20sweet%20moment%2C%20soft%20peach%20and%20cream%20background%2C%20charming%20comic%20illustration%2C%20gentle%20lighting%2C%20clean%20composition&width=600&height=800&seq=comic-sweet-campus&orientation=portrait',
    tags: ['校园', '甜宠', '日常'],
    chapters: '更新至 158 话',
    rating: '9.4',
    status: '连载中',
    desc: '学霸少女与同桌学渣的爆笑甜蜜日常，每周都能在通勤路上磕到糖。',
    heat: '热榜第 2',
  },
  {
    id: 'spirit-court',
    title: '仙途问鼎',
    author: '云巅画社',
    category: '玄幻修仙',
    cover: 'https://readdy.ai/api/search-image?query=epic%20cultivation%20fantasy%20manga%20cover%20of%20a%20mystic%20swordmaster%20floating%20above%20clouds%20with%20golden%20energy%2C%20warm%20amber%20and%20cream%20background%2C%20majestic%20comic%20art%2C%20detailed%20illustration&width=600&height=800&seq=comic-spirit-court&orientation=portrait',
    tags: ['修仙', '热血', '爽文'],
    chapters: '更新至 412 话',
    rating: '9.7',
    status: '连载中',
    desc: '一介散修逆天改命，问鼎仙途巅峰，剧情环环相扣根本停不下来。',
    heat: '热榜第 3',
  },
  {
    id: 'midnight-case',
    title: '午夜档案室',
    author: '墨线侦探社',
    category: '悬疑推理',
    cover: 'https://readdy.ai/api/search-image?query=atmospheric%20mystery%20manga%20cover%20of%20a%20detective%20examining%20evidence%20at%20a%20moody%20desk%20lamp%2C%20deep%20brown%20and%20dark%20amber%20tones%2C%20suspenseful%20comic%20illustration%2C%20cinematic%20lighting&width=600&height=800&seq=comic-midnight-case&orientation=portrait',
    tags: ['悬疑', '推理', '烧脑'],
    chapters: '已完结 120 话',
    rating: '9.3',
    status: '已完结',
    desc: '每一桩午夜案件背后都藏着秘密，跟着主角抽丝剥茧还原真相。',
    heat: '热榜第 4',
  },
  {
    id: 'daily-laugh',
    title: '今天也想摸鱼',
    author: '打工人画室',
    category: '搞笑日常',
    cover: 'https://readdy.ai/api/search-image?query=funny%20slice-of-life%20manga%20cover%20with%20cartoon%20characters%20sneaking%20coffee%20and%20snacks%20at%20work%2C%20playful%20warm%20yellow%20background%2C%20humorous%20comic%20illustration%2C%20cheerful%20vibes&width=600&height=800&seq=comic-daily-laugh&orientation=portrait',
    tags: ['搞笑', '日常', '职场'],
    chapters: '更新至 86 话',
    rating: '9.2',
    status: '连载中',
    desc: '爆笑打工人漫画，把每天的摸鱼日常画得又真实又好笑。',
    heat: '热榜第 5',
  },
  {
    id: 'mecha-rose',
    title: '机甲蔷薇',
    author: '铁与花工作室',
    category: '科幻机甲',
    cover: 'https://readdy.ai/api/search-image?query=mecha%20sci-fi%20manga%20cover%20of%20a%20female%20pilot%20standing%20beside%20a%20colossal%20warm-colored%20battle%20robot%2C%20bronze%20and%20cream%20background%2C%20dynamic%20comic%20art%2C%20epic%20composition&width=600&height=800&seq=comic-mecha-rose&orientation=portrait',
    tags: ['科幻', '机甲', '战斗'],
    chapters: '更新至 204 话',
    rating: '9.5',
    status: '连载中',
    desc: '少女驾驶着最后一台原型机甲，在星际战争中守护人类的希望。',
    heat: '热榜第 6',
  },
];

export const readingFeatures = [
  {
    icon: 'ri-smartphone-line',
    title: '移动端流畅翻页',
    desc: '为手机屏幕深度优化，上下滑动与横屏翻页都顺滑跟手，点开即读。',
  },
  {
    icon: 'ri-bookmark-3-fill',
    title: '一键收藏书单',
    desc: '喜欢的漫画一键加入书单，分类管理、离线缓存，想读就读。',
  },
  {
    icon: 'ri-notification-3-fill',
    title: '追更不错过',
    desc: '订阅更新推送，新话上线第一时间提醒，通勤路上也不怕错过。',
  },
  {
    icon: 'ri-download-cloud-2-line',
    title: '离线缓存阅读',
    desc: '追更内容支持离线缓存，无网络也能畅快翻阅，地铁信号差也不慌。',
  },
  {
    icon: 'ri-eye-line',
    title: '护眼阅读模式',
    desc: '夜间模式与亮度调节，长时间阅读也舒适，保护你的双眼。',
  },
  {
    icon: 'ri-global-line',
    title: '跨设备同步',
    desc: '安卓版与 iOS 版阅读进度云端同步，换机也能无缝衔接继续看。',
  },
];

export const testimonials = [
  {
    name: '小北',
    role: '上班族 · 通勤党',
    avatar: 'https://readdy.ai/api/search-image?query=cute%20cartoon%20avatar%20portrait%20of%20a%20friendly%20young%20man%20with%20glasses%2C%20warm%20cream%20background%2C%20playful%20flat%20illustration&width=200&height=200&seq=ava-1&orientation=squarish',
    text: '每天早上挤地铁都在咪咕漫画网追《星焰纪元》，翻页很顺滑，缓存下来没信号也能看，通勤时间瞬间没那么难熬了。',
    tag: '通勤阅读',
  },
  {
    name: '糖糖',
    role: '大学生',
    avatar: 'https://readdy.ai/api/search-image?query=cute%20cartoon%20avatar%20portrait%20of%20a%20cheerful%20young%20woman%20with%20long%20hair%2C%20warm%20cream%20background%2C%20playful%20flat%20illustration&width=200&height=200&seq=ava-2&orientation=squarish',
    text: '收藏追更真的很方便，更新推送特别准时。安卓版下载后界面清爽，没有乱七八糟的广告，阅读体验满分。',
    tag: '追更体验',
  },
  {
    name: '老猫',
    role: '资深漫友',
    avatar: 'https://readdy.ai/api/search-image?query=cartoon%20avatar%20portrait%20of%20a%20calm%20mature%20man%20with%20short%20beard%2C%20warm%20cream%20background%2C%20playful%20flat%20illustration&width=200&height=200&seq=ava-3&orientation=squarish',
    text: '书库分类很全，热血、甜宠、悬疑都有，还支持横屏翻页。iOS 版体验稳定，换了手机进度也自动同步过来了。',
    tag: '内容丰富',
  },
  {
    name: '阿岚',
    role: '漫画家',
    avatar: 'https://readdy.ai/api/search-image?query=cartoon%20avatar%20portrait%20of%20a%20stylish%20young%20woman%20with%20short%20hair%2C%20warm%20cream%20background%2C%20playful%20flat%20illustration&width=200&height=200&seq=ava-4&orientation=squarish',
    text: '作为创作者也在用咪咕漫画网手机版，阅读数据反馈清楚，读者互动氛围好，是看国漫很好的平台。',
    tag: '国漫生态',
  },
];

export const faqs = [
  {
    q: '咪咕漫画网手机版和 APP 有什么区别？',
    a: '咪咕漫画网手机版是无需下载的网页版，点开即可在线阅读，适合临时快速浏览；APP 则提供更完整的体验，包括离线缓存、更新推送和横屏翻页等功能。两者阅读进度支持云端同步。',
  },
  {
    q: '如何下载咪咕漫画网 APP？安卓版和 iOS 版在哪里下？',
    a: '在页面顶部点击"下载 APP"即可看到安卓版与 iOS 版下载入口。安卓版提供安装包下载，iOS 版可通过应用商店获取。下载前请确认系统版本满足要求。',
  },
  {
    q: '咪咕漫画网 APP 支持离线缓存阅读吗？',
    a: '支持。在 APP 中打开任意漫画，点击缓存按钮即可将章节离线保存，没有网络也能在通勤路上流畅翻页阅读，且支持夜间护眼模式。',
  },
  {
    q: '追更的漫画更新了会提醒我吗？',
    a: '会。在 APP 中订阅你关注的漫画后，新话上线时会通过推送提醒你，避免错过更新。网页版也可以通过收藏列表查看最新更新时间。',
  },
  {
    q: '阅读进度可以跨设备同步吗？',
    a: '可以。登录同一账号后，安卓版、iOS 版以及手机网页版的阅读进度都会自动同步，更换设备也能无缝衔接继续阅读。',
  },
  {
    q: '咪咕漫画网手机版需要付费吗？',
    a: '咪咕漫画网提供大量免费章节供手机版用户阅读，部分作品支持付费解锁后续章节，具体以作品页面标注为准。下载 APP 本身是免费的。',
  },
];

export const footerLinks = [
  { title: '平台服务', links: ['关于我们', '帮助中心', '版权声明', '联系客服'] },
  { title: '内容分类', links: ['热血冒险', '恋爱甜宠', '玄幻修仙', '悬疑推理'] },
  { title: '资源下载', links: ['安卓版下载', 'iOS 版下载', '手机版入口', '常见问题'] },
];